<template>
  <div v-if="invoices.length > 0" class="ack-list">
    <h3 class="page-title section-title">
      {{ $t('importers.index.ack.toBeEsigned') }}
    </h3>
    <invoice-list-table :invoices="invoices" ref="invoiceList" />
    <form-button
      :loading="loading"
      @click="generateEsign"
      variant="primary"
      size="lg"
      >{{ $t('importers.index.ack.esignNow') }}</form-button
    >
  </div>
</template>
<script>
import FormButton from '@/components/common/FormButton'
import InvoiceListTable from './InvoiceListTable'
import invoiceService from '@/services/invoice'

export default {
  data() {
    return {
      loading: false,
      esignUrl: null
    }
  },
  props: ['invoices'],
  components: {
    FormButton,
    InvoiceListTable
  },
  computed: {
    redirectUrl() {
      return process.env.VUE_APP_DRIP_PORTAL_HOST
    }
  },
  methods: {
    allowEsign() {
      return (
        this.$refs.invoiceList.invoices.filter((invoice) => {
          return invoice.selected === true
        }).length > 0
      )
    },
    generateEsign() {
      if (!this.allowEsign()) {
        return
      }
      this.loading = true
      const signableAcks = this.$refs.invoiceList.invoices
        .filter((element) => element.selected === true)
        .map((element) => element.id)
      return invoiceService
        .fetchDocsAndAckSign({
          vars: {
            account_id: this.$store.state.account.accountId,
            user_id:
              this.$store.state.account && this.$store.state.account.user.id,
            post_redirect: this.redirectUrl,
            invoice_ids: signableAcks
          }
        })
        .then((res) => {
          this.loading = false
          return this.$router.push({
            name: 'importerEsign',
            params: {
              esignUrl: res.data.redirect_url
            }
          })
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
          return this.$notify({
            title: this.$t('notifications.somethingWrong.title'),
            text: this.$t('notifications.somethingWrong.text'),
            type: 'error'
          })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.ack-list {
  padding: 40px 0;
}
</style>
